import { Text } from 'src/design/atoms/Text';
import React from 'react';

import { JobDto } from 'src/api/FiretrolApiClient';
import { LinkButton } from 'src/design/atoms/LinkButton';

interface MilestoneCellProps {
  milestoneTitle: string | undefined;
  jobNumber: string | undefined;
  linkedDetails: Record<string, JobDto>;
}

export const MilestoneCell: React.FC<MilestoneCellProps> = ({
  milestoneTitle,
  jobNumber,
  linkedDetails,
}) => {
  if (!milestoneTitle) return <Text c="dimmed">--</Text>;
  const id = jobNumber ? linkedDetails[jobNumber.trim()]?.id : undefined;
  if (!id) return <Text size="xs">{milestoneTitle}</Text>;
  return (
    <LinkButton size="compact-xs" to={`/jobs/${id}/milestones`}>
      {milestoneTitle}
    </LinkButton>
  );
};
